// @flow

const getStreetError = (street: string): string | null => {
  if (street.length === 0) {
    return "Straatnaam is niet ingevuld.";
  }
};

export default getStreetError;
